<div class="chart" echarts [options]="options" *ngIf="data && data.points?.length && !sparse && !allZero"></div>
<div class="legend" *ngIf="data && data.points?.length && !sparse && !allZero">
  <span><b class="booked"></b>{{ 'dashboard.company.bench_forecast_booked' | translate }}</span>
  <span><b class="bench"></b>{{ 'dashboard.company.bench_forecast_bench' | translate }}</span>
</div>
<p class="bf-sparse" *ngIf="data && data.points?.length && sparse">{{ 'dashboard.company.bench_forecast_insufficient' | translate }}</p>
<!-- allZero is a real reading (no one active in-horizon), not missing data, so it states
     the fact rather than borrowing the insufficient-data copy (see company-util-trend for
     the same conflation shipping a bug on capacity-forecast). -->
<p class="bf-sparse" *ngIf="data && data.points?.length && !sparse && allZero">{{ 'dashboard.company.bench_forecast_all_zero' | translate }}</p>
